module.exports = __webpack_public_path__ + "76f5da1d71f987e72626ce8c46a0fb4c.jpg";